import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useDispatch } from "react-redux";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useLocation, useNavigate } from "react-router-dom";
import PullToRefresh from "react-simple-pull-to-refresh";
import { setLanguage } from "../../core/feature/language/languageSlice";
import { setToken } from "../../core/feature/token/tokenSlice";
import { setUser } from "../../core/feature/user/userSlice";
import { credentialCheck } from "../../core/service/api";
import { i18n } from "../../translations/i18n";
import { ChevronLeft, X } from "lucide-react";
import User from "../../core/models/user";
import { useAppSelector } from "../../core/feature/hooks";
import Config from "../../config/Config";
import { Tab } from "@headlessui/react";
import { QuickAmountComponent } from "./components/quickAmountComponent";
import { ManualInputComponent } from "./components/manualInputComponent";
import { setLoading } from "../../core/feature/config/configSlice";
import { getConfigSavings, sumbitSaving } from "../../core/service/api_saving";
import { toast } from "react-toastify";
import { BottomSheet } from "react-spring-bottom-sheet";
import moment from "moment";
import { formatCurrency } from "../../config/global";
import { SavingInformationComponent } from "./components/savingsInformationComponents";

export type FormType = {
  callerId: string;
  amount: number;
  configId: string;
  channel: string;
  tag?: string;
  note?: string;
};

const SavingCreateMobile = (props: any) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [isToken, setIsToken] = useState<any>(false);
  const { t } = useTranslation();
  const env = Config.BaseUrlDev;

  const [activeUser, setActiveUser] = useState({} as any);
  const [savingsData, setSavingsData] = useState<any>();
  const [activeTab, setActiveTab] = useState(0);
  const [amount, setAmount] = useState<number>(0);
  const [openConfirmation, setOpenConfirmation] = useState<boolean>(false);
  const [accountConfig, setAccountConfig] = useState<any>({});

  const dismissConfirmation = () => {
    setOpenConfirmation(false);
  };

  const handleRefresh = async () => {};

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }

  function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(" ");
  }

  const handleChangeValue = (value: number) => {
    setAmount(value);
  };

  const handleSave = async () => {
    console.log(accountConfig);

    if (!accountConfig.unlimitedMaxBalance) {
      if (
        Number(accountConfig.balance) + amount >
        accountConfig.maxBalanceLimit
      ) {
        return toast.warn(
          `Tabungan tidak dapat ditambahkan, maksimal saldo tabungan ${formatCurrency(accountConfig.maxBalanceLimit)}`,
        );
      }
    }
    if (accountConfig.minBalanceSaving > 0) {
      if (amount < accountConfig.minBalanceSaving) {
        return toast.warning(
          `Minimal setoran ${formatCurrency(accountConfig.minBalanceSaving)}.`,
        );
      }
    }
    // return;

    const form: FormType = {
      callerId: activeUser.callerId,
      amount: amount,
      configId: savingsData?.configId,
      channel: "MOBILE",
      tag: "",
    };
    try {
      dispatch(setLoading(true));
      const { data } = await sumbitSaving(form);
      dispatch(setLoading(false));
      toast.success("Success");
      console.log(data);

      navigate("/saving/mutation", {
        state: {
          data,
          activeUser,
        },
      });
    } catch (error) {
      dispatch(setLoading(false));
      // toast.error("error");
    }
  };

  useEffect(() => {
    // getComboStudent();
    setActiveUser(location.state.activeUser[0] ?? {});
    setSavingsData(location.state.savingAccount ?? {});
    console.log(location.state.activeUser);
    console.log(getImgContent(location.state.activeUser[0].photoUrl));
    getConfigSavings(location.state.savingAccount.configId).then(
      ({ data }: any) => {
        console.log(data);
        setAccountConfig(data);
      },
    );
  }, [location.state]);

  return (
    <>
      <div className="relative min-h-screen h-full  bg-psp-primary pb-10">
        <PullToRefresh className="text-center" onRefresh={handleRefresh}>
          <div className="text-left  px-4 py-6 bg-psp-primary font-montserrat">
            <div className="flex d-flex w-full">
              <button>
                <ChevronLeft
                  className="bg-white w-8 h-8 rounded-lg border p-1"
                  onClick={() => navigate(`/saving`)}
                />
              </button>
              <div className="absolute left-1/2 -translate-x-1/2 font-bold text-xl">
                {t("SAVING.createSaving")}
              </div>
            </div>
            {/* User Information card */}
            <section className="mt-3 w-full">
              <div className="flex flex-col justify-start h-full w-full">
                <div className="flex flex-col gap-2 justify-center items-center w-full">
                  <img
                    src={getImgContent(activeUser?.photoUrl)}
                    alt=""
                    className="w-[12vh] h-[12vh] mx-3 my-3 rounded-full"
                  />
                  <div className="flex flex-col items-center">
                    <span className="font-medium text-base">
                      {activeUser.name}
                    </span>
                    <span className="text-sm">{activeUser.callerId}</span>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <Tab.Group
                onChange={(index) => {
                  console.log("Changed selected tab to:", index);
                  setActiveTab(index);
                }}
              >
                <Tab.List className="flex space-x-1 justify-around p-1">
                  <Tab
                    className={({ selected }) =>
                      classNames(
                        "w-1/3 py-2.5 text-sm font-medium px-2",
                        " ",
                        selected
                          ? "font-montserrat border-b-2 border-blue-700 text-blue-700 text-sm font-semibold active:border-b-2 focus:border-b-2"
                          : "text-slate-400 font-montserrat text-sm font-semibold",
                      )
                    }
                  >
                    {t("SAVING.quickInput")}
                  </Tab>
                  <Tab
                    className={({ selected }) =>
                      classNames(
                        "w-1/3 py-2.5 text-sm font-medium px-2",
                        " ",
                        selected
                          ? "font-montserrat border-b-2 border-blue-700 text-blue-700 text-sm font-semibold active:border-b-2 focus:border-b-2"
                          : "text-slate-400 font-montserrat text-sm font-semibold",
                      )
                    }
                  >
                    {t("SAVING.manualInput")}
                  </Tab>
                </Tab.List>
                <Tab.Panels>
                  <Tab.Panel>
                    <div className="flex flex-col gap-3">
                      <QuickAmountComponent
                        data={savingsData}
                        onChangeValue={handleChangeValue}
                      />
                      <SavingInformationComponent
                        data={accountConfig}
                        savingsAccount={savingsData}
                      />
                    </div>
                  </Tab.Panel>
                  <Tab.Panel>
                    <div className="flex flex-col gap-3">
                      <ManualInputComponent onChangeValue={handleChangeValue} />
                      <SavingInformationComponent
                        data={accountConfig}
                        savingsAccount={savingsData}
                      />
                    </div>
                  </Tab.Panel>
                </Tab.Panels>
              </Tab.Group>
            </section>
            <div className="w-full bottom-0 fixed left-0 p-3 border-none">
              <button
                className="bg-blue-700 p-2 rounded-full w-full text-white"
                onClick={() => setOpenConfirmation(true)}
              >
                {t("PROFILE.confirm")}
              </button>
            </div>
          </div>
        </PullToRefresh>
      </div>

      {/* confrim submit */}
      <BottomSheet
        open={openConfirmation}
        onDismiss={dismissConfirmation}
        defaultSnap={({ snapPoints, lastSnap }) =>
          lastSnap ?? Math.min(...snapPoints)
        }
        className="font-montserrat"
        snapPoints={({ maxHeight }) => [
          maxHeight - maxHeight / 5,
          maxHeight * 0.6,
        ]}
        header={
          <div className="flex items-center justify-between">
            <span className="font-poppins flex items-left text-base font-bold text-black">
              {t("SAVING.confirmTitle")}
            </span>
            <button onClick={() => dismissConfirmation()}>
              <X />
            </button>
          </div>
        }
        footer={
          <div className="flex gap-2 z-[1000]">
            {/* <button className="disabled:bg-psp-gray w-full bg-white shadow-lg  text-psp-primary  border-1 border-psp-primary border-solid py-2.5 text-sm font-semibold rounded-lg">
                  {t("INVOICE.share")}
                </button> */}
            <button
              onClick={() => dismissConfirmation()}
              className={`disabled:bg-psp-gray w-full shadow-lg py-2.5 text-sm font-semibold rounded-full bg-danger text-white`}
            >
              {t("PROFILE.cancel")}
            </button>
            <button
              onClick={() => handleSave()}
              className={`disabled:bg-psp-gray w-full shadow-lg  py-2.5 text-sm font-semibold rounded-full bg-blue-700 text-white`}
            >
              {t("PROFILE.confirm")}
            </button>
          </div>
        }
      >
        <div className="flex flex-col gap-1 p-4">
          <span className="mt-2 font-semibold">{t("SAVING.confirmation")}</span>
          <div className="flex justify-between items-center mt-4 text-sm">
            <span>{t("SAVING.transactionType")}</span>
            <span>{t("SAVING.saving")}</span>
          </div>
          <div className="flex justify-between items-center text-sm">
            <span>{t("SAVING.savingType")}</span>
            <span>{savingsData?.savingName}</span>
          </div>
          <div className="flex justify-between items-center text-sm">
            <span>{t("SAVING.transactionTime")}</span>
            <span>{moment(Date.now()).format("DD-MM-YYYY, HH.mm")}</span>
          </div>
          <div className="flex justify-between items-center text-sm">
            <span>{t("SAVING.callerName")}</span>
            <span>{savingsData?.callerName}</span>
          </div>
          <div className="flex justify-between items-center text-sm">
            <span>NIS</span>
            <span>{savingsData?.callerId}</span>
          </div>
          <div className="flex justify-between items-center text-sm font-bold">
            <span>{t("SAVING.total")}</span>
            <span>{formatCurrency(amount)}</span>
          </div>
        </div>
      </BottomSheet>
    </>
  );
};

export default SavingCreateMobile;
